<template>

    <div>
        <div v-if="multiLingual===true && dataIsVisible">

            <b-form-group
                    class="c-text"
                    :label-for="'field' + id"
                    :label="label"
                    :label-cols="labelCols"
                    :aria-describedby="id + '_InvalidFeedback'">

                <template slot="description">
                    <label v-html="description"></label>
                </template>

                <b-tabs fill>
                    <b-tab v-for="language, languageIndex in Core.Local.languages">
                        <template slot="title">
                            {{language.label}}
                        </template>
                        <b-form-input
                                v-if="required"
                                type="text"
                                :readonly="readOnly"
                                :id="id + '_' + language.value"
                                :state="chkState(id)"
                                v-model="dataValue[language.value]"
                                :placeholder="placeholder"
                                :autocomplete="autocomplete"></b-form-input>
                        <b-form-input
                                v-else
                                type="text"
                                :id="id + '_' + language.value"
                                :readonly="readOnly"
                                v-model="dataValue[language.value]"
                                :placeholder="placeholder"
                                :autocomplete="autocomplete"></b-form-input>
                    </b-tab>
                </b-tabs>
                <b-form-invalid-feedback :id="id + '_InvalidFeedback'">
                    {{invalidFeedbackMessage}}
                </b-form-invalid-feedback>
            </b-form-group>
        </div>

        <div v-if="multiLingual===false && dataIsVisible">
            <b-form-group
                    class="c-text"
                    :label-for="'field' + id"
                    :label-cols="labelCols"
                    :label="label"
                    :aria-describedby="id + '_InvalidFeedback'">

                <template slot="description">
                    <label v-html="description"></label>
                </template>

                <b-form-input
                        v-if="required"
                        type="text"
                        :readonly="readOnly"
                        :id="'field' + id"
                        :state="chkState(id)"
                        v-model="dataValue"
                        :placeholder="placeholder"
                        :autocomplete="autocomplete"></b-form-input>
                <b-form-input
                        v-else
                        type="text"
                        :id="'field' + id"
                        :readonly="readOnly"
                        v-model="dataValue"
                        :placeholder="placeholder"
                        :autocomplete="autocomplete"></b-form-input>
                <b-form-invalid-feedback :id="id + '_InvalidFeedback'">
                    {{invalidFeedbackMessage}}
                </b-form-invalid-feedback>
            </b-form-group>
        </div>
    </div>

</template>

<script>
  export default {
      name: 'InputText',
      props: {
          required: {
              type: Boolean,
              default: false
          },
          value: {
              type: String | Object,
              default: ''
          },
          id: {
              type: String,
              default: ''
          },
          label: {
              type: String,
              default: ''
          },
          placeholder: {
              type: String,
              default: ''
          },
          description: {
              type: String,
              default: ''
          },
          labelCols: {
              type: Number,
              default: 0
          },
          autocomplete: {
              type: String,
              default: ''
          },
          readOnly: {
              type: Boolean,
              default: false
          },
          invalidFeedbackMessage: {
              type: String,
              default: ''
          },
          _isVisible: {
              type: Boolean,
              default: true
          },
          form: {
              type: Object,
              default: function() {return {}}
          },
          fieldRefs: {
              type: Array,
              default: function() { return [] }
          },
          multiLingual: {
              type: Boolean,
              default: false
          }
      },
      watch: {
          value(val) {
              if (this.multiLingual) {
                  val = Core.Local.prepareValue(val)
              }
              this.dataValue = val
          },
          dataValue(val) {
              if (this.multiLingual) {
                  val = Core.Local.prepareValue(val)
              }
              this.$emit('input', val)
          }
      },
      mounted() {
          this.dataIsVisible = this._isVisible
          if(this.multiLingual) {
              this.dataValue = Core.Local.prepareValue(this.value)
          } else {
              this.dataValue = this.value
          }
      },
      data: () => {
          return {
              dataValue: '',
              dataIsVisible: true,
              Core: window.Core
          }
      },
      computed: {
          isVisible: {
              set(val) {
                  this.dataIsVisible = val
              },
              get() {
                  return this.dataIsVisible
              }
          }
      },
      methods: {
          chkState(val) {
              if (this.form !== undefined && this.form[val] !== undefined) {
                  const field = this.form[val]
                  return !field.$dirty || !field.$invalid
              }
          }
      }
  }
</script>